// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"135":"9541a903","178":"bcdfd600","971":"21859e80"}[chunkId] + ".chunk.css";
};